
import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import "../assets/css/admin/sidebar.css";

function Sidebar() {

    const navigate = useNavigate();

    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = () => {

        localStorage.removeItem("isAdminLoggedIn");

        navigate("/admin/login");

    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    return (

        <>
            {/* Mobile Sidebar Button */}
            <button
                className="sidebar-toggle"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                aria-label="Toggle sidebar"
            >

                {sidebarOpen ? "✕" : "☰"}

            </button>


            {/* Mobile Overlay */}
            {sidebarOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={closeSidebar}
                ></div>
            )}


            {/* Sidebar */}
            <aside className={`sidebar ${sidebarOpen ? "sidebar-open" : ""}`}>

                <h2>
                    📷 Story Line Studios
                </h2>


                <NavLink
                    to="/admin/layout"
                    onClick={closeSidebar}
                >
                    🏠 Dashboard
                </NavLink>


                <NavLink
                    to="/admin/upload"
                    onClick={closeSidebar}
                >
                    📤 Upload Photo
                </NavLink>


                <NavLink
                    to="/admin/upload-video"
                    onClick={closeSidebar}
                >
                    🎥 Upload Video
                </NavLink>


                <NavLink
                    to="/admin/gallery-categories"
                    onClick={closeSidebar}
                >
                    🖼 Gallery Categories
                </NavLink>


                <NavLink
                    to="/admin/manage-packages"
                    onClick={closeSidebar}
                >
                    📦 Package Management
                </NavLink>


                <NavLink
                    to="/admin/feedback"
                    onClick={closeSidebar}
                >
                    ⭐ Feedback
                </NavLink>


                <NavLink
                    to="/admin/contact"
                    onClick={closeSidebar}
                >
                    📩 Contact Messages
                </NavLink>


                <NavLink
                    to="/admin/homemedia"
                    onClick={closeSidebar}
                >
                    🖼 Home Background
                </NavLink>


                <button
                    onClick={handleLogout}
                    className="logout-btn"
                >
                    🚪 Logout
                </button>

            </aside>

        </>

    );

}

export default Sidebar;

